import { defineStyleConfig, type ComponentStyleConfig } from '@chakra-ui/react';

const config: ComponentStyleConfig = {
  baseStyle: {
    bg: 'background',
    color: 'text',
    boxShadow: 'none',
  },
};

export const Tooltip = defineStyleConfig(config);
